import { render } from "./VoiceGallary.vue?vue&type=template&id=20543962&scoped=true"
import script from "./VoiceGallary.vue?vue&type=script&lang=js"
export * from "./VoiceGallary.vue?vue&type=script&lang=js"

import "./VoiceGallary.vue?vue&type=style&index=0&id=20543962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20543962"]])

export default __exports__